import { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AppContexts } from "../../providers";
import AnnouncementsService from "../../services/announcements.service";
import AnnouncementCard from "../announcements/card";
import { mergeAnnouncementHistory } from "../announcements/model";
import "../features/features.css";

const WhatsNew = () => {
  const { user } = useContext(AppContexts.AuthContext);
  const { hash } = useLocation();
  const [result, setResult] = useState({ accountId: null, items: [], status: "loading" });
  const [attempt, setAttempt] = useState(0);
  const accountId = user?.account_id;
  const current = result.accountId === accountId ? result : { items: [], status: "loading" };
  const announcements = current.status === "ready" ? mergeAnnouncementHistory(current.items) : [];

  useEffect(() => { document.title = "What's New - RueBaRue"; }, []);
  useEffect(() => {
    let active = true;
    setResult({ accountId, items: [], status: "loading" });
    AnnouncementsService.listAnnouncements().then((response) => {
      if (!Array.isArray(response.data)) throw new Error("Unexpected announcement response");
      if (active) setResult({ accountId, items: response.data, status: "ready" });
    }).catch(() => {
      if (active) setResult({ accountId, items: [], status: "error" });
    });
    return () => { active = false; };
  }, [accountId, attempt]);

  useEffect(() => {
    if (current.status === "ready" && hash.startsWith("#announcement-")) {
      document.getElementById(hash.slice(1))?.scrollIntoView?.({ block: "start" });
    }
  }, [current.status, hash]);

  return (
    <section id="whats-new-page" className="rbr-whats-new-page">
      <div id="hms-page-title"><h1 className="uk-heading-small">What's New</h1></div>
      <div id="hms-main-body">
        <div className="rbr-discovery-intro"><div><p>Find new features and improvements, with instructions to help you get started.</p></div><Link className="uk-button hms-btn hms-white-btn uk-flex-inline uk-flex-middle" to="/features">Explore all features →</Link></div>
        {current.status === "loading" && <p role="status">Loading updates…</p>}
        {current.status === "error" && <div className="rbr-discovery-error" role="alert">We couldn’t load updates. <button type="button" onClick={() => setAttempt((value) => value + 1)}>Try again</button></div>}
        {current.status === "ready" && (announcements.length ? <div className="rbr-feature-grid">{announcements.map((announcement) => <AnnouncementCard key={announcement.id} announcement={announcement} anchored />)}</div> : <div className="rbr-feature-empty"><h2>No updates yet</h2><p>You can still discover RueBaRue capabilities and instructions in Your Features.</p><Link className="uk-button hms-btn hms-red-btn uk-flex-inline uk-flex-middle" to="/features">Browse features →</Link></div>)}
      </div>
    </section>
  );
};

export default WhatsNew;
